module.exports = __webpack_public_path__ + "static/media/goback_icon.22cce094.svg";